$(document).ready(() => {
    const PAGE_LENGTH = 10;

    $('.teamVersusStatsBlock').each(setupTable);

    function setupTable() {
        const $teamVersusStatsBlock = $(this);

        let gamesTypeFilter = 'all';
        let tournamentFilter = 'all';
        let tournamentTierFilter = 'all';
        let displayStart = 0;
        let order = [[7, 'desc']];

        const currentUrl = TRNMNT_helpers.parseUrl();
        const $gameTypeFilter = $teamVersusStatsBlock.find('.gameTypeFilter');
        const $tournamentFilter = $teamVersusStatsBlock.find('.tournamentFilter');
        const $tournamentTierFilter = $teamVersusStatsBlock.find('.tournamentTierFilter');

        const preserveFiltering = currentUrl.segments.indexOf('player') !== -1;

        if (preserveFiltering && currentUrl.params) {
            if (currentUrl.params.tvgtf) {
                $gameTypeFilter.val(currentUrl.params.tvgtf);
                gamesTypeFilter = currentUrl.params.tvgtf;
            }
            if (currentUrl.params.tvtf) {
                $tournamentFilter.val(currentUrl.params.tvtf);
                tournamentFilter = currentUrl.params.tvtf;
            }
            if (currentUrl.params.tvttrf) {
                $tournamentTierFilter.val(currentUrl.params.tvttrf);
                tournamentTierFilter = currentUrl.params.tvttrf;
            }
            if (currentUrl.params.tvds) {
                displayStart = currentUrl.params.tvds;
            }
            if (currentUrl.params.tvoc && currentUrl.params.tvod) {
                order = [[currentUrl.params.tvoc, currentUrl.params.tvod]];
            }
        }

        const $table = $teamVersusStatsBlock.find('.teamVersusStatsTable')
            .DataTable({
                language: {
                    url: '/dataTables.ru.json'
                },
                scrollX: true,
                displayStart: displayStart,
                pageLength: PAGE_LENGTH,
                lengthChange: false,
                layout: {
                    bottomEnd: {
                        paging: {
                            firstLast: false,
                        },
                    },
                },
                info: false,
                // processing: true,
                serverSide: true,
                ajax: {
                    url: TEAMS_VERSUS_URL,
                    data: function (d) {
                        if (gamesTypeFilter !== 'all') {
                            d.games_type = gamesTypeFilter;
                        }
                        if (tournamentFilter !== 'all') {
                            d.tournament_id = tournamentFilter;
                        }
                        if (tournamentTierFilter !== 'all') {
                            d.tier = tournamentTierFilter;
                        }
                    },
                },
                order: order,
                search: {
                    return: true,
                },
                paging: !MAIN,
                searching: false,
                dataSrc: 'data',
                columns: [
                    //Порядковый
                    {
                        data: null,
                        className: "align-middle rounded-start text-end stats-data-platform",
                        orderable: false,
                        render: (data, type, full, meta) => {
                            const row = meta.row
                                + 1
                                + meta.settings._iDisplayLength
                                * Math.ceil(meta.settings._iDisplayStart / meta.settings._iDisplayLength);

                            return `<small class="text-muted">${row}</small>`;
                        },
                    },
                    //Аватар
                    {
                        data: null,
                        className: "align-middle stats-data-avatar",
                        orderable: false,
                        render: data => {
                            return `
                        <a href="${data.link}" class="fw-bold me-2 text-decoration-none"><img class="rounded-circle"
                             style="height: 50px; width: 50px;"
                             src="${data.avatar}"
                             alt="${data.title}}"
                        /></a>`;
                        },
                    },
                    //Платформа
                    {
                        data: null,
                        className: "align-middle stats-data-platform",
                        orderable: false,
                        render: data => {
                            return data.platform_id
                                ? `
                                    <i class="fa-brands fa-${data.platform_id}"
                                    style="color: ${TRNMNT_helpers.getPlatformColor(data.platform_id)}"
                                    ></i>`
                                : null;
                        },
                    },
                    //Название
                    {
                        data: null,
                        className: "align-middle title-row",
                        orderable: false,
                        render: data => {
                            const badge = data.country_id
                                ? `<span class="fi fi-${data.country_id} fis rounded-circle"></span>`
                                : `<a href="${data.link}" class="badge bg-secondary rounded-pill text-decoration-none" style="background: ${data.background} !important; color: ${data.color} !important; border: ${data.color} 1px solid">${data.short_title}</a>`;

                            return `<a href="${data.link}" class="fw-bold me-2 text-decoration-none">${data.title}</a> ${badge}`;
                        },
                    },
                    //Турниров
                    {
                        data: 'tournaments',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //% побед
                    {
                        data: 'wins_percent',
                        className: "align-middle text-center fw-bold stats-data",
                        render: data => data + '%',
                        orderSequence: ['desc', 'asc']
                    },
                    //Игры
                    {
                        data: 'games',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //Побед
                    {
                        data: 'wins',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //Поражения
                    {data: 'loses', className: "align-middle text-center fw-bold stats-data"},
                    //Поражения в овертайме
                    {data: 'lose_overtime', className: "align-middle text-center fw-bold stats-data"},
                ],
                createdRow(row) {
                    // $(row).addClass(tournamentTypeFilter === '3' ? 'bg-3x3' : 'bg-dark');
                    $(row).addClass('bg-dark');
                },
                initComplete: (settings, json) => {
                    $('div.dataTables_filter input').addClass('form-control-dark');
                }
            });

        if (preserveFiltering) {
            $table.on('page.dt', function () {
                const info = $table.page.info();
                const displayStart = info.page * PAGE_LENGTH;
                TRNMNT_helpers.insertURLQueryParam('tds', displayStart);

                $([document.documentElement, document.body]).animate({
                    scrollTop: $teamVersusStatsBlock.find('.teamStatsTable').offset().top - 160
                }, 0);
            });

            $table.on('order.dt', function () {
                // This will show: "Ordering on column 1 (asc)", for example
                const order = $table.order();
                TRNMNT_helpers.insertURLQueryParam('tvoc', order[0][0]);
                TRNMNT_helpers.insertURLQueryParam('tvod', order[0][1]);
                TRNMNT_helpers.insertURLQueryParam('tvds', 0);
            });
        }

        $gameTypeFilter.on('change', event => {
            event.preventDefault();
            gamesTypeFilter = $(event.target).val();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tvgtf', gamesTypeFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tvds', 0);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tvoc', 4);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tvod', 'desc');

            $table.draw();
        });

        $tournamentFilter.on('change', event => {
            event.preventDefault();
            tournamentFilter = $(event.target).val();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tvtf', tournamentFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tvds', 0);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tvoc', 4);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tvod', 'desc');

            $table.draw();
        });

        $tournamentTierFilter.on('change', event => {
            event.preventDefault();
            tournamentTierFilter = $(event.target).val();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tvttrf', tournamentTierFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tvds', 0);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tvoc', 4);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tvod', 'desc');

            $table.draw();
        });
    }
});
